import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { CATEGORIES } from '../lib/constants';
import { useTheme } from '../context/ThemeContext';
import { supabase } from '../lib/supabase';

const { FiHome, FiSettings, FiList, FiDatabase, FiInfo, FiLayers, FiSun, FiMoon, FiX, FiLogOut } = FiIcons;

const Sidebar = ({ isOpen, toggle }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (window.confirm('Möchtest du dich wirklich abmelden?')) {
      await supabase.auth.signOut();
      navigate('/');
    }
  };

  const navItems = [
    { to: '/', icon: FiHome, label: 'Dashboard' },
    { type: 'divider', label: 'Inventar' },
    ...Object.entries(CATEGORIES).map(([key, conf]) => ({ to: `/inventory/${key}`, icon: FiDatabase, label: conf.label })),
    { type: 'divider', label: 'Verwaltung' },
    { to: '/lists', icon: FiList, label: 'Listen-Pflege' },
    { to: '/settings', icon: FiSettings, label: 'Import / Export' },
    { to: '/impressum', icon: FiInfo, label: 'Impressum' },
  ];

  return (
    <aside className={`fixed inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:relative md:translate-x-0 transition-transform duration-300 ease-in-out z-[70] w-64 bg-slate-900 text-white flex flex-col shadow-2xl md:shadow-none h-full`}>
      <div className="flex-none p-6 pt-[calc(env(safe-area-inset-top)+1.5rem)] md:pt-6 border-b border-slate-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiLayers} className="text-2xl text-yellow-500" />
          <h1 className="text-xl font-bold tracking-tight">MoBa<span className="text-yellow-500">Inventar</span></h1>
        </div>
        <button onClick={toggle} className="md:hidden p-2 text-slate-400 hover:text-white bg-slate-800 rounded-lg">
          <SafeIcon icon={FiX} className="text-xl" />
        </button>
      </div>

      <nav className="flex-1 overflow-y-auto py-4 scrollbar-hide">
        <ul>
          {navItems.map((item, idx) => {
            if (item.type === 'divider') {
              return <li key={idx} className="px-6 py-4 mt-2 text-[9px] font-black text-slate-500 uppercase tracking-widest">{item.label}</li>;
            }
            return (
              <li key={item.to + idx}>
                <NavLink to={item.to} onClick={() => { if (window.innerWidth < 768) toggle(); }} className={({ isActive }) => `flex items-center px-6 py-3 transition-all duration-200 ${isActive ? 'bg-yellow-600 text-white shadow-lg z-10' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}`} >
                  <SafeIcon icon={item.icon} className="mr-3 text-lg shrink-0" />
                  <span className="text-sm font-medium truncate">{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="flex-none p-4 pb-[calc(env(safe-area-inset-bottom)+1rem)] md:pb-4 border-t border-slate-800 space-y-2 bg-slate-900">
        <div className="grid grid-cols-2 gap-2">
          <button onClick={toggleTheme} className="flex items-center justify-center gap-2 py-3 px-2 rounded-xl bg-slate-800 hover:bg-slate-700 transition-colors text-[10px] font-bold" >
            <SafeIcon icon={isDarkMode ? FiSun : FiMoon} className={isDarkMode ? 'text-yellow-400' : 'text-blue-400'} />
            {isDarkMode ? 'HELL' : 'DUNKEL'}
          </button>
          <button onClick={handleLogout} className="flex items-center justify-center gap-2 py-3 px-2 rounded-xl bg-slate-800 hover:bg-red-900/40 text-red-400 transition-colors text-[10px] font-bold" title="Abmelden" >
            <SafeIcon icon={FiLogOut} />
            LOGOUT
          </button>
        </div>
        <div className="text-[9px] text-center text-slate-500 uppercase tracking-tighter leading-tight pt-2">
          © 2026 MoBa Inventar App v1.2.0<br />Michael Fayaud
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;